import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Breadcrumb,
  Card,
  Skeleton,
  Button,
  Col,
  message,
  Modal,
} from 'antd';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import allBillersRoute from 'modules/AllBillers/route';
import OneRowData from 'components/OneRowData';
import Table from 'components/Table';
import CallbackModal from 'components/CallbackModal';
import { formatDateTimeDetail, formatMoney } from 'shared/utils/StringUtil';
import { permissionService } from 'shared/services';

import textService from './ServiceDetail.page.translation';

import './ServiceDetail.style.less';

const { checkPermission } = permissionService;

class ServiceDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNow: 1,
      pageSize: 5,
      totalItem: 5,
      showModalRestore: false,
      showModalNotification: false,
      isSuccess: false,
    };
  }
  getServiceId = () => this.props.match.params.id;

  componentDidMount() {
    const id = this.getServiceId();
    const defaultParam = {
      page_num: this.state.pageNow,
      page_size: this.state.pageSize,
    };
    this.props.getListBillerService(id, defaultParam, this.callbackPagination);
    this.props.getService(id);
  }

  callbackPagination = pagination => {
    if (pagination.page_num) {
      const totalItem = pagination.page_size * pagination.page_count;
      this.setState({
        pageNow: pagination.page_num,
        totalItem,
      });
    } else {
      message.error({
        content: 'Whoops Something Error!',
        key: 'serviceBiller',
        duration: 5,
      });
    }
  };

  handleChangePage = page => {
    const id = this.getServiceId();
    const currentFilter = { page_num: page, page_size: 5 };
    this.props.getListBillerService(id, currentFilter, this.callbackPagination);
  };

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(textService.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={allBillersRoute.SERVICES}>
              {formatMessage(textService.serviceTitle)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {formatMessage(textService.detailTitle)}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  renderLeftData = () => {
    const {
      service,
      loading,
      intl: { formatMessage },
    } = this.props;
    const listLeftData = [
      {
        label: formatMessage(textService.label.serviceId),
        value: service.public_id,
      },
      {
        label: formatMessage(textService.label.serviceName),
        value: service.name,
      },
      {
        label: formatMessage(textService.label.publicServiceName),
        value: service.public_name,
      },
      {
        label: formatMessage(textService.label.serviceIcon),
        url: service.icon_abs_url,
        style: {
          width: '38px',
          height: '38px',
          borderRadius: '2px',
        },
      },
      {
        label: formatMessage(textService.label.serviceBanner),
        url: service.banner_abs_url,
        inline: true,
        style: {
          width: '200px',
          height: '80px',
          borderRadius: '2px',
        },
      },
      {
        label: 'ServiceURL',
        value: _.get(service, 'page_url', ''),
        class: 'url-preview',
      },
      {
        label: 'IconURL',
        value: service.icon_abs_url,
        class: 'url-preview',
      },
      {
        label: formatMessage(textService.label.status),
        value: service.is_active ? 'Active' : 'Inactive',
      },
    ];
    const listLeftSection = listLeftData.map(element => (
      <OneRowData key={element.label} data={element} />
    ));
    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 8,
            width: ['100%', '100%', '100%', '100%'],
          }}
          title={false}
        >
          {listLeftSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  renderRightData = () => {
    const {
      service,
      loading,
      intl: { formatMessage },
    } = this.props;
    const listRightData = [
      // {
      //   label: formatMessage(textService.label.danaDivisionId),
      //   value: service.dana_merchant_division_id
      //     ? service.dana_merchant_division_id
      //     : '',
      // },
      {
        label: formatMessage(textService.label.defaultForm),
        value: service.default_form ? service.default_form.name : '',
      },
      {
        label: formatMessage(textService.label.aggregator),
        value: service.aggregator || 'DANA X2X',
      },
      {
        label: formatMessage(textService.label.serviceCategory),
        value: service.category,
      },
      {
        label: formatMessage(textService.label.keyword),
        value: service.universal_keyword,
      },
      {
        label: formatMessage(textService.label.nameMask),
        value: service.should_mask_beneficiary_full_name ? 'Yes' : 'No',
      },
      {
        label: formatMessage(textService.label.archived),
        value: service.archived_at ? 'Yes' : 'No',
      },
      {
        label: formatMessage(textService.label.transactionFee),
        value: formatMoney(service.transaction_fee),
      },
      {
        label: formatMessage(textService.label.createdat),
        value: formatDateTimeDetail(service.created_at || ''),
      },
      {
        label: formatMessage(textService.label.updatedat),
        value: formatDateTimeDetail(service.updated_at || ''),
      },
    ];
    const listRightSection = listRightData.map(element => (
      <OneRowData key={element.label} data={element} />
    ));
    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 8,
            width: ['100%', '100%', '100%', '100%'],
          }}
          title={false}
        >
          {listRightSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  statusTabelCase = status => {
    const {
      intl: { formatMessage },
    } = this.props;
    switch (status) {
      case '2':
        return (
          <span className="status-text active">
            {formatMessage(textService.status.active)}
          </span>
        );
      case '1':
        return (
          <span className="status-text inactive">
            {formatMessage(textService.status.inactive)}
          </span>
        );
      default:
        return (
          <span className="status-text hidden">
            {formatMessage(textService.status.hidden)}
          </span>
        );
    }
  };

  renderBillName = row => {
    const link = allBillersRoute.BILLERS_DETAIL.replace(':id', row.id);
    return <Link to={link}>{row.name}</Link>;
  };

  renderNoColumn = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { pageNow, pageSize } = this.state;
    if (pageNow === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (pageNow - 1) * pageSize;
    }
    return modifyIndex;
  };

  getRowId = row => row.id;

  tableColumns = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: formatMessage(textService.biller.label.no),
        key: 'index',
        render: this.renderNoColumn,
      },
      {
        title: formatMessage(textService.biller.label.name),
        key: 'name',
        render: this.renderBillName,
      },
      {
        title: formatMessage(textService.biller.label.billerId),
        dataIndex: 'public_id',
        key: 'billerId',
      },
      {
        title: formatMessage(textService.biller.label.playgroundStatus),
        dataIndex: 'pground_status',
        key: 'playgroundStatus',
        render: this.statusTabelCase,
      },
      {
        title: formatMessage(textService.biller.label.skywalkerStatus),
        dataIndex: 'skyw_status',
        key: 'skywStatus',
        render: this.statusTabelCase,
      },
    ];
  };

  goToEditService = () => {
    const { history } = this.props;
    const serviceId = this.getServiceId();
    const link = allBillersRoute.SERVICES_EDIT.replace(':id', serviceId);
    history.push(link);
  };

  renderModalTitle(title) {
    return <Row className="modal-title-form-builder">{title}</Row>;
  }

  handleCancelArchive = () => {
    this.setState({
      showModalRestore: false,
    });
  };

  handleRestorePopUp = () => {
    this.setState({
      showModalRestore: true,
    });
  };

  getDescriptionNotification = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    const { isSuccess } = this.state;

    if (isSuccess) {
      return formatMessage(textService.confirmation.message.restore);
    }

    return '';
  };

  callbackModalNotification = (_id, status) => {
    this.setState({
      showModalNotification: true,
      isSuccess: status,
    });
  };

  onCloseModalNotification = () => {
    this.setState({
      showModalNotification: false,
      isSuccess: true,
    });
  };

  handleUnarchive = () => {
    const { updateStatus } = this.props;
    const id = this.getServiceId();
    updateStatus(id, 'unarchive', this.callbackModalNotification);
    this.setState({
      showModalRestore: false,
    });
  };

  showModalRestore() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { showModalRestore } = this.state;
    return (
      <Modal
        title={this.renderModalTitle(
          formatMessage(textService.confirmation.title),
        )}
        visible={showModalRestore}
        footer={null}
        closable={false}
        className="modal-confirmation"
      >
        <center>
          {formatMessage(textService.confirmation.archive, {
            status: (
              <strong key="restore">
                {formatMessage(textService.label.restore)}
              </strong>
            ),
          })}
        </center>
        <center>{formatMessage(textService.confirmation.extra.restore)}</center>
        <center className="btn-group-change">
          <Button className="btn-cancel" onClick={this.handleCancelArchive}>
            {formatMessage(textService.btn.cancel)}
          </Button>
          <Button
            className="btn-change"
            type="primary"
            onClick={this.handleUnarchive}
          >
            {formatMessage(textService.btn.restore)}
          </Button>
        </center>
      </Modal>
    );
  }

  renderButtonEditRestore() {
    const {
      intl: { formatMessage },
      service,
    } = this.props;
    const textType = service.archived_at ? 'restore' : 'edit';
    const onClickBtn = service.archived_at
      ? this.handleRestorePopUp
      : this.goToEditService;

    return (
      <Button
        type="primary"
        size="large"
        className={`btn-${textType}-service`}
        onClick={onClickBtn}
      >
        {formatMessage(textService.btn[textType])}
      </Button>
    );
  }

  render() {
    const {
      pageNow,
      pageSize,
      totalItem,
      showModalNotification,
      isSuccess,
    } = this.state;
    const {
      intl: { formatMessage },
      history,
      loading,
      listBillerService,
      service,
    } = this.props;

    return (
      <div className="main-content service-detail">
        {this.renderBreadCrumb()}
        <div className="white-box-wrapper">
          <span className="title">{formatMessage(textService.viewTitle)}</span>
          <Card className="card-service-detail" bordered={false}>
            <Row type="flex">
              {this.renderLeftData()}
              {this.renderRightData()}
            </Row>
          </Card>

          <Row className="btn-edit-wrapper">
            {checkPermission('Service:update', true) &&
              this.renderButtonEditRestore()}
            {this.showModalRestore()}
          </Row>
          <CallbackModal
            modalVisible={showModalNotification}
            type={isSuccess ? 'success' : 'failed'}
            onClose={this.onCloseModalNotification}
            btnText="Close"
            description={this.getDescriptionNotification()}
          />
        </div>

        <div className="white-box-wrapper">
          <Row type="flex" justify="space-between" align="middle">
            <Col>
              <span className="title">
                {formatMessage(textService.biller.detailService)}
              </span>
            </Col>
            <Col>
              {checkPermission('Biller:create', true) && (
                <Button
                  type="primary"
                  size="large"
                  className="btn-new-biller"
                  onClick={() => {
                    history.push(allBillersRoute.BILLERS_CREATE, {
                      serviceId: this.getServiceId(),
                    });
                  }}
                  disabled={!!service.archived_at}
                >
                  {formatMessage(textService.biller.btn.create)}
                </Button>
              )}
            </Col>
          </Row>
          <div className="table-wrapper">
            <Table
              rowID={this.getRowId}
              columns={this.tableColumns()}
              dataSource={listBillerService}
              pagination="true"
              rowClass="striped-table"
              loadingValue={loading}
              currentPage={pageNow}
              pageSize={pageSize}
              totalItem={totalItem}
              changePage={this.handleChangePage}
            />
          </div>
        </div>
      </div>
    );
  }
}

ServiceDetail.propTypes = {
  intl: PropTypes.object,
  getService: PropTypes.func,
  getListBillerService: PropTypes.func,
  service: PropTypes.object,
  listBillerService: PropTypes.array,
  loading: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object,
  updateStatus: PropTypes.func,
};

export default ServiceDetail;
